import "./Expertise.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurMethodology from "./sections/OurMethodology";
import FullScaleProduction from "./sections/FullScaleProduction";
import StudioFooter from "@/reusable_sections/Footer";
export default function ExpertisePage() {
  return <div>
      <MainNavigation />
      <OurMethodology />
      <FullScaleProduction />
      <StudioFooter />
    </div>;
}